'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMedal, faBadgeCheck, faScaleBalanced } from '@awesome.me/kit-46a3f5ad26/icons/sharp/light';
import { faAward } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import Tooltip from '@/app/_components/Tooltip';
import 'flag-icons/css/flag-icons.min.css';
const capitalize = str => str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
const ProductTrustBadges = t0 => {
  const $ = _c(24);
  const {
    supplierName,
    demonym,
    countryName,
    countryCode,
    isBestSeller,
    productName
  } = t0;
  const [activeTooltip, setActiveTooltip] = useState(null);
  const article = demonym && /^[aeiou]/i.test(demonym) ? "an" : "a";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = id => isOpen => {
      setActiveTooltip(isOpen ? id : null);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const createOpenChangeHandler = t1;
  const t2 = supplierName || "Brand";
  let t3;
  if ($[1] !== t2) {
    t3 = <span>Authorized <span className="capitalize">{t2}</span> Dealer</span>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `As an authorized ${supplierName || "brand"} retailer, every purchase comes with full manufacturer warranty and support.`;
  let t5;
  let t6;
  if ($[3] !== activeTooltip || $[4] !== t3 || $[5] !== t4) {
    const badges = [{
      id: "authorized-dealer",
      icon: faMedal,
      text: t3,
      tooltip: t4
    }, {
      id: "authentic-product",
      icon: faBadgeCheck,
      text: "Authentic Product",
      tooltip: "Every item we carry is fully authenticated, authorized, and sourced directly from the original manufacturers."
    }, {
      id: "price-match",
      icon: faScaleBalanced,
      text: "100% Price Match",
      tooltip: "Found a lower price? We'll match most authorized dealer's advertised price."
    }];
    t5 = "flex flex-wrap gap-x-10 gap-y-6 text-sm text-light my-10";
    t6 = badges.map(badge => {
      const isActive = activeTooltip === badge.id;
      return <Tooltip key={badge.id} content={badge.tooltip} side="bottom" onOpenChange={createOpenChangeHandler(badge.id)}><span className="group flex items-center gap-2 cursor-default"><FontAwesomeIcon icon={badge.icon} className={`text-lg transition-colors duration-300 ${isActive ? "text-green-600" : "group-hover:text-green-600"}`} /><span className={`transition-colors duration-300 ${isActive ? "text-primary" : "group-hover:text-primary"}`}>{badge.text}</span></span></Tooltip>;
    });
    $[3] = activeTooltip;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== activeTooltip || $[9] !== article || $[10] !== countryCode || $[11] !== countryName || $[12] !== demonym || $[13] !== supplierName) {
    t7 = demonym && countryName && countryCode && (() => {
      const countryId = `country-${countryCode.toLowerCase()}`;
      const isActive_0 = activeTooltip === countryId;
      return <Tooltip key={countryId} content={`${supplierName} is ${article} ${demonym} brand.`} side="bottom" onOpenChange={createOpenChangeHandler(countryId)}><span className="group flex items-center gap-2 cursor-default"><span className={`fi fi-${countryCode.toLowerCase()} text-lg transition-all duration-300 ${isActive_0 ? "grayscale-0 opacity-100" : "grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100"}`} /><span className={`transition-colors duration-300 ${isActive_0 ? "text-primary" : "group-hover:text-primary"}`}>{demonym} Brand</span></span></Tooltip>;
    })();
    $[8] = activeTooltip;
    $[9] = article;
    $[10] = countryCode;
    $[11] = countryName;
    $[12] = demonym;
    $[13] = supplierName;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== activeTooltip || $[16] !== isBestSeller || $[17] !== productName) {
    t8 = isBestSeller && (() => {
      const isActive_1 = activeTooltip === "best-seller";
      return <Tooltip key="best-seller" content={`The ${capitalize(productName)} is a best seller.`} side="bottom" onOpenChange={createOpenChangeHandler("best-seller")}><span className="group flex items-center gap-2 cursor-default"><FontAwesomeIcon icon={faAward} className={`text-lg transition-colors duration-300 ${isActive_1 ? "text-green-600" : "group-hover:text-green-600"}`} /><span className={`transition-colors duration-300 ${isActive_1 ? "text-primary" : "group-hover:text-primary"}`}>Best Seller</span></span></Tooltip>;
    })();
    $[15] = activeTooltip;
    $[16] = isBestSeller;
    $[17] = productName;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <div className={t5}>{t6}{t7}{t8}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
export default ProductTrustBadges;